"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _base = require("@mui/base");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const App = () => {
  const {
    setIsLoading,
    setToastText,
    setToastOpen,
    sendUpdatePasswordMail
  } = (0, _common.useCommonStore)();
  const [email, setEmail] = _react.default.useState('');
  const [emailConfirm, setEmailConfirm] = _react.default.useState('');
  const [errors, setErrors] = _react.default.useState({
    email: '',
    emailConfirm: '',
    submit: ''
  });
  const [, setLocation] = (0, _wouter.useLocation)();
  const emailRef = _react.default.useRef(null);
  const emailConfirmRef = _react.default.useRef(null);
  const submitRef = _react.default.useRef(null);
  const validate = () => {
    let hasError = false;
    let errorText = '';
    const newErrors = {
      email: '',
      emailConfirm: '',
      submit: ''
    };
    if (!email) {
      newErrors.email = 'メールアドレスを入力してください';
      hasError = true;
      errorText = 'メールアドレスを入力してください\n';
    }
    if (!emailConfirm) {
      newErrors.emailConfirm = 'メールアドレスを入力してください';
      hasError = true;
      errorText = 'メールアドレス(確認用)を入力してください\n';
    }
    if (email !== emailConfirm) {
      newErrors.emailConfirm = 'メールアドレスが一致しません';
      hasError = true;
      errorText = 'メールアドレスが一致しません\n';
    }
    if (!hasError) {
      var _emailRef$current;
      if (!((_emailRef$current = emailRef.current) !== null && _emailRef$current !== void 0 && _emailRef$current.checkValidity())) {
        newErrors.email = 'メールアドレスを正しく入力してください';
        errorText = 'メールアドレスを正しく入力してください\n';
        hasError = true;
      }
    }
    setErrors(newErrors);
    if (hasError) {
      setToastText(errorText);
      setToastOpen(true);
    }
    return !hasError;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...stylex.props(_Style.wrapper.fill, _Style.wrapper.center),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "column",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      rowSpacing: 6,
      sx: {
        height: '100vh',
        width: '33vw'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u30D5\u30A9\u30FC\u30E0"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        container: true,
        direction: "column",
        rowSpacing: 2,
        size: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          direction: "column",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            spacing: 1,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
              label: "\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
              ref: emailRef,
              type: "email",
              errorText: errors.email,
              value: email,
              placeholder: '登録したメールアドレスを入力してください)',
              onChange: event => {
                setEmail(event.target.value);
              },
              onEnterKey: () => {
                var _emailConfirmRef$curr;
                (_emailConfirmRef$curr = emailConfirmRef.current) === null || _emailConfirmRef$curr === void 0 ? void 0 : _emailConfirmRef$curr.focus();
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            spacing: 1,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
              label: "\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9(\u78BA\u8A8D)",
              ref: emailConfirmRef,
              type: "email",
              errorText: errors.emailConfirm,
              value: emailConfirm,
              placeholder: '登録したメールアドレスを入力してください)',
              onChange: event => {
                setEmailConfirm(event.target.value);
              },
              onEnterKey: () => {
                var _submitRef$current;
                (_submitRef$current = submitRef.current) === null || _submitRef$current === void 0 ? void 0 : _submitRef$current.focus();
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
              ...stylex.props(_Style.textStyle.p1b, _Style.buttonStyle.primary),
              disabled: !email || !emailConfirm,
              ref: submitRef,
              onClick: async () => {
                if (!validate()) return;
                setIsLoading(true);
                if (!(await sendUpdatePasswordMail(email))) {
                  setToastText('メール送信中にエラーが発生しました');
                  setToastOpen(true);
                  setIsLoading(false);
                  return;
                }
                setToastText('パスワード再設定メールを送信しました。(※未登録のメールアドレスの場合はメールが送られません)');
                setToastOpen(true);
                setIsLoading(false);
                setLocation('/');
              },
              children: 'パスワード再設定メールを受け取る'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
              ...stylex.props(_Style.textStyle.p1b, _Style.buttonStyle.primary),
              onClick: async () => {
                setLocation('/');
              },
              children: 'ログイン画面に戻る'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            minHeight: 48,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.error),
              children: errors.submit
            })
          })]
        })
      })]
    })
  });
};
var _default = exports.default = App;